import { createSlice } from "@reduxjs/toolkit";

export const idTokenSlice = createSlice({
  name: "idToken",
  initialState: {
    value: "",
  },
  reducers: {
    setIdToken: (state, action) => {
      state.value = action.payload;
    },
    clearIdToken: (state, action) => {
      state.value = "";
    },
  },
});

export const { setIdToken, clearIdToken } = idTokenSlice.actions;

export default idTokenSlice.reducer;
